<template>
  <div :class="{ 'campaign-loading': isLoading }">
    <v-progress-circular
      v-if="isLoading"
      :size="70"
      :width="7"
      color="primary"
      indeterminate
      class="centered"
    ></v-progress-circular>
    <div class="row">
      <div class="text-right align-self-end">
        <button
          class="btn btn-outline-primary"
          @click="() => $router.push({ name: 'DetailReferralCampaign' })"
        >
          + New Campaign
        </button>
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <BrandDropdown
          v-model="brandSelected"
          @setBrand="setBrand"
        ></BrandDropdown>
      </div>
      <div class="col-3">
        <label for="searchText">Search</label>
        <input
          id="searchText"
          type="text"
          class="form-control py-2"
          placeholder="Search by campaign name, privilege name..."
          v-model="searchText"
          @keyup.enter="searchCampaign"
        />
      </div>
    </div>
    <div class="d-flex justify-content-end">
      <div class="p-2 align-self-center">
        <button class="btn btn-outline-secondary" @click="resetFilter">
          Reset
        </button>
      </div>
      <div class="p-2 align-self-center">
        <button class="btn btn-outline-primary" @click="searchCampaign">
          Search
        </button>
      </div>
    </div>
    <div class="mt-3">
      <div class="row">
        <div class="d-flex align-items-center justify-content-start col">
          <span class="mr-2">Show</span>
          <b-form-select
            class="form-control w-auto"
            v-model="perPage"
            :options="pageOptions"
            @change="onChangeEntries"
          ></b-form-select>
          <span class="ml-2">entries</span>
        </div>
      </div>
      <b-table
        class="table table-responsive table-bordered mt-5"
        hover
        responsive
        :fields="fields"
        :items="listCampaigns"
        :per-page="perPage"
        @sort-changed="sortCompare"
        show-empty
      >
        <template #empty>
          <h1 class="text-center m-5">ไม่มีข้อมูลที่แสดง</h1>
        </template>
        <template #cell(action)="data">
          <div class="d-flex justify-content-evenly">
            <router-link
              :to="{
                name: 'DetailReferralCampaign',
                query: { id: data.item.id },
              }"
              class="btn btn-outline-primary"
              >Edit</router-link
            >
          </div>
        </template>
      </b-table>
      <b-pagination
        :total-rows="totalItems"
        v-model="currentPage"
        :per-page="perPage"
        class="my-0"
        @input="changePage"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import BrandDropdown from "components/Brand/BrandDropdown";
import DefaultListViewData from "@/views/defaultListViewData";
import fields from "@/views/ReferralCampaign/listReferralCampaignFields.json";
import ReferralCampaignService from "services/api/referralCampaign.service";
import moment from "moment/moment";

export default {
  components: {
    BrandDropdown,
  },

  data() {
    return {
      ...DefaultListViewData,
      isLoading: true,
      listCampaigns: [],
      fields,
    };
  },
  mounted() {
    this.getCampaigns();
  },
  methods: {
    async getCampaigns() {
      const params = {
        brandCode: this.brandSelected ? this.brandSelected.id : null,
        key: this.searchText,
        currentPage: this.currentPage,
        limit: this.perPage,
        sortColumn: this.sort.key || "lastUpdated",
        sortType: this.sort.type === "asc" ? "asc" : "desc",
      };

      await ReferralCampaignService.getListReferralCampaigns(params)
        .then((res) => {
          const data = res.data;
          this.totalItems = data.totalItem;
          this.listCampaigns = data.campaigns.map((c) => {
            return {
              ...c,
              status: c.status === "ACTIVE" ? "Active" : "Inactive",
              period:
                moment(c.startDate).format("YYYY-MM-DD") +
                " - " +
                moment(c.endDate).format("YYYY-MM-DD"),
              referrerPrivilege: c.referrerPrivilegeName,
              refereePrivilege: c.refereePrivilegeName,
            };
          });

          this.isLoading = false;
        })
        .catch((err) => {
          console.log("Error: ", err);
          this.isLoading = false;
        });
    },
    changePage() {
      this.getCampaigns();
    },
    onChangeEntries() {
      this.getCampaigns();
    },
    sortCompare(e) {
      let sortBy = e.sortBy === "brandName" ? "brandCode" : e.sortBy;
      this.sort = {
        key: sortBy,
        type: e.sortDesc ? "desc" : "asc",
      };
      this.getCampaigns();
    },
    setBrand(brand) {
      this.brandSelected = brand || null;
    },
    searchCampaign() {
      this.isLoading = true;
      this.getCampaigns();
    },
    resetFilter() {
      this.brandSelected = null;
      this.searchText = null;
      this.getCampaigns();
    },
  },
};
</script>

<style lang="scss" scoped>
.centered {
  position: absolute;
  top: 45%;
  left: 50%;
}
.campaign-loading > :not(:first-child) {
  pointer-events: none;
  opacity: 0.4;
}
</style>
